export default {"src":"/_next/static/media/ReviewLogo3.e45148f4.svg","height":127,"width":186,"blurWidth":0,"blurHeight":0};